module.exports = __webpack_public_path__ + "static/32-648b18b416426880f67b7cddce818c64.gif";